import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import SubNav from 'ROOT_SOURCE/components/SubNav'
import SideBar from 'ROOT_SOURCE/components/SideBar'

import Audit from './Audit'
import Business from './Business'
import Majors from './Majors'
import Basic from './Basic'
import Record from './Record'
import Regulations from './Regulations'
import Report from './Report'
import Statement from './Statement'
import Team from './Team'

import './index.scss'

const plates = [
    {
        text: '备案信息',
        url: '/infodcs/record'
    },
    {
        text: '组织结构',
        url: '/infodcs/team'
    },
    {
        text: '审核信息',
        url: '/infodcs/audit'
    },
    {
        text: '经营信息',
        url: '/infodcs/business'
    },
    {
        text: '重大事项',
        url: '/infodcs/majors'
    },
    {
        text: '运营报告',
        url: '/infodcs/report'
    },
    {
        text: '法律法规',
        url: '/infodcs/regulations'
    },
    {
        text: '基本信息',
        url: '/infodcs/basic'
    },
    {
        text: '信披声明',
        url: '/infodcs/statement'
    }
]

const InfoDcs = ({ match }) => {
    return (
        <div className="InfoDcs">
            <SubNav selected="infodcs" />
            <div className="main-box">
                <div className="main">
                    <SideBar plates={plates} />
                    <div className="section">
                        <Switch>
                            <Route path={`${match.url}/audit`} component={Audit} />
                            <Route path={`${match.url}/business`} component={Business} />
                            <Route path={`${match.url}/majors`} component={Majors} />
                            <Route path={`${match.url}/basic`} component={Basic} />
                            <Route path={`${match.url}/record`} component={Record} />
                            <Route path={`${match.url}/regulations`} component={Regulations} />
                            <Route path={`${match.url}/report`} component={Report} />
                            <Route path={`${match.url}/statement`} component={Statement} />
                            <Route path={`${match.url}/team`} component={Team} />
                            <Redirect to={`${match.url}/record`} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InfoDcs;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/index.js